import axios from 'axios'

import { env } from '@/config/env'

export const companiesApi = axios.create({
  baseURL: env.apiURL,
})

export const usersApi = axios.create({
  baseURL: env.apiURL,
})

export const ibgeApi = axios.create({
  baseURL: env.ibgeApiURL,
})
